'use client';

import '@livekit/components-styles';

import { BackgroundEffectProvider } from './context/BackgroundContextProvider';
import { DevicesAlertContextProvider } from './context/DevicesAlertDialogContext';
import { DevicesInfoContextProvider } from './context/DevicesInfoContext';

import type { ReactNode } from 'react';

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <DevicesInfoContextProvider>
      <DevicesAlertContextProvider>
        <BackgroundEffectProvider>{children}</BackgroundEffectProvider>
      </DevicesAlertContextProvider>
    </DevicesInfoContextProvider>
  );
};

export default Layout;
